<template>
	<v-dialog ref="dialog_ref" modal_class="all-filters-modal" @closed="emit(`close`)">
		<template #header>
			<div class="modal-header-inner">
				<h2>All filters</h2>

				<p>Refine your job search</p>
			</div>
		</template>

		<filter-inline-checkboxes
			v-model="draft.work_environments"
			icon="house"
			label="Remote options"
			:options="store.lists.work_environments"
		/>

		<filter-inline-salary
			v-model:salary_period="draft.salary_period"
			v-model:require_salary="draft.require_salary"
			v-model:salary_min="draft.salary_min"
			icon="cash-back"
			label="Salary"
		/>

		<filter-inline-checkboxes
			v-model="draft.work_schedules"
			icon="clock"
			label="Work schedule"
			:options="store.lists.work_schedules"
		/>

		<filter-inline-checkboxes
			v-model="draft.employment_types"
			icon="building"
			label="Employment type"
			:options="store.lists.employment_types"
		/>

		<filter-inline-checkboxes
			v-model="draft.experiences"
			icon="sparkles"
			label="Experience"
			:options="store.lists.experiences"
		/>

		<filter-inline-checkboxes
			v-model="draft.qualifications"
			icon="education"
			label="Education"
			:options="store.lists.qualifications"
		/>

		<template #footer>
			<div class="modal-footer-inner">
				<button type="button" class="btn btn-bordered" @click="reset_draft">Reset filters</button>

				<button type="button" class="btn btn-solid" @click="apply">Apply filters</button>
			</div>
		</template>
	</v-dialog>
</template>

<style lang="scss" scoped>
@use 'sass:math';

@use '/sass/variables' as *;
@use '/sass/toolkit' as *;

.modal-header-inner {
	h2 {
		@include h4;
		margin-bottom: 0;
	}

	p {
		color: $text;
		font-size: 0.875rem;
	}
}

.modal-footer-inner {
	display: flex;
	align-items: center;
	gap: math.div($spacer, 2);

	.btn-solid,
	.btn-bordered {
		font-size: 1em;
	}

	.btn-solid {
		margin-left: auto;
	}
}
</style>

<script setup>
import { reactive, ref } from 'vue';

import FilterInlineCheckboxes from './_filter-inline-checkboxes.vue';
import FilterInlineSalary from './_filter-inline-salary.vue';
import { store } from './_store.js';
import VDialog from './_v-dialog.vue';

const props = defineProps({
	data: {
		type: Object,
		required: true,
	},
	defaults: {
		type: Object,
		required: true,
	},
	filter_keys: {
		type: Array,
		required: true,
	},
});

const emit = defineEmits([`close`, `apply`]);

const dialog_ref = ref(null);

function clone_value(value) {
	if (Array.isArray(value)) {
		return [...value];
	}

	return value;
}

function build_draft(source) {
	const draft = {};

	for (const key of props.filter_keys) {
		draft[key] = clone_value(source[key]);
	}

	return draft;
}

const draft = reactive(build_draft(props.data));

function reset_draft() {
	Object.assign(draft, build_draft(props.defaults));
}

function apply() {
	emit(`apply`, {
		...draft,
	});

	dialog_ref.value?.close();
}
</script>
